import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { MapData, MapMarkerType } from './interfaces/MapData.interface';
import { MyAccountService } from 'src/app/pages/my-account/services/my-acount.service';
import * as bootstrap from 'bootstrap';
import { HttpClient } from '@angular/common/http';
import { GoogleMapsService } from 'src/app/services/google-maps.service';
import { SummaryData } from 'src/app/pages/new-service/interfaces/SummaryData';
import { DistanceUnitByZoneId } from '../pipes/DistanceUnitByZoneId.pipe';
import { filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { PublicRequestService, publicRoutes } from 'src/app/services/public-request.service';
import { LatLng } from 'src/app/pages/new-service/interfaces/LongitudeLatitude';
declare let google: any;
import * as uuid from 'uuid';
import { UserProfile } from 'src/app/pages/my-account/interfaces/company-settings.interface';

export interface DistanceTimeInfoRequest {
  Distance: number;
  Time: number;
  ZoneId?: string
}


export interface DistanceTimeInfo {
  Distance: string;
  Time: string;
  ZoneId?: string
}

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  providers: [DistanceUnitByZoneId]
})
export class MapComponent implements OnInit, OnChanges, AfterViewInit {
  private _markers: MapData[] = [];

  isPublicRoute: boolean = false;

  @Input()
  set markers(value: MapData[]) {
    this._markers = value;
    if (this.map) {
      this.updateMap();
    }
  }

  @Input() showDistanceTimeLabel: boolean = false;
  @Input() travelInfo: DistanceTimeInfo | null = null;
  @Input() LabelInfoPosition: LatLng | null = null;
  @Input() LabelVehicleInfoHTML: string = "";


  @Input() summaryData: SummaryData = {} as SummaryData;

  get markers(): MapData[] {
    return this._markers;
  }
  @Input() isHome = false;
  @Input() isActiveRoutes = false;
  @Input() isPickUpLocation = false;
  currentPath = window.location.pathname;
  @Output() locationSelected: EventEmitter<void> = new EventEmitter();
  @Output() markerClicked: EventEmitter<MapData> = new EventEmitter<MapData>();



  mapID = `${uuid.v4()}_map`

  stylesWithStreetLabels = [
    {
      featureType: 'all',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{ visibility: 'on' }],
    },
  ];

  onlyStreetLabelsStyle = [
    {
      featureType: 'all',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'road',
      elementType: 'labels.text',
      stylers: [{ visibility: 'on' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ visibility: 'on' }]
    },
    {
      featureType: 'transit',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'administrative',
      stylers: [{ visibility: 'on' }]
    },
    {
      featureType: 'water',
      stylers: [{ visibility: 'on' }]
    },
    {
      featureType: 'landscape',
      stylers: [{ visibility: 'on' }]
    }
  ];

  stylesWithoutStreetLabels = [
    {
      featureType: 'all',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
  ];

  map: any;
  private polylines: google.maps.Polyline[] = [];
  defaultPositionLatitude = 0;
  defaultPositionLongitude = 0;
  private currentMarkers: google.maps.Marker[] = [];

  constructor(private myAccountService: MyAccountService, private http: HttpClient, private googleMapsService: GoogleMapsService, private DistanceUnitByZoneId: DistanceUnitByZoneId, private router: Router, private PublicRequestService: PublicRequestService) {

  }

  ngOnInit(): void {
    this.loadDefaultPosition();
  }


  ngAfterViewInit(): void {
    this.loadDefaultPosition();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['markers'] || changes['travelInfo'] || changes['LabelInfoPosition'] || changes['LabelVehicleInfoHTML']) {
      if (this.map) {
        this.showTravelInfoWindow()
        this.updateMap();
      }
    }
  }


  travelInfoWindow: any = null;

  showTravelInfoWindow() {
    if (!this.map || (!this.travelInfo && !this.LabelVehicleInfoHTML) || !this.showDistanceTimeLabel || this.markers.length <= 1) {
      this.travelInfoWindow?.close();
      return
    };

    const origin = this._markers[0];
    const destination = this._markers[1];

    // Usa la posición enviada por el padre si existe
    const position = this.LabelInfoPosition
      ? this.LabelInfoPosition
      : {
        lat: (origin.lat! + destination.lat!) / 2,
        lng: (origin.lng! + destination.lng!) / 2
      };

    if (this.travelInfoWindow) {
      this.travelInfoWindow.close();
    }

    this.travelInfoWindow = new google.maps.InfoWindow({
      content: this.LabelVehicleInfoHTML ? this.LabelVehicleInfoHTML : `<div class="maps-label-route-info-label">
      <div class="maps-label-vehicle-image">
        <img  src="../../../assets/coche-productos.svg" alt="Car" />
      </div>
      <div class="maps-label-route-info-content">
        <div class="maps-label-route-info-distance">
          <img src="../../../assets/icons/route-lable-icon.svg" alt="Route" />
          <p>${this.travelInfo?.Distance}</p>
        </div>
        <div class="maps-label-route-info-time">
          <p>${this.travelInfo?.Time}</p>
        </div>
      </div>
    </div>`,
      position,
    });

    this.travelInfoWindow.open(this.map);
    this.styleInfoWindow();
  }


  private styleInfoWindow() {
    google.maps.event.addListener(this.travelInfoWindow, 'domready', () => {
      const closeBtn = document.querySelector('.gm-ui-hover-effect');
      if (closeBtn) {
        (closeBtn as HTMLElement).style.display = 'none';
      }

      const header = document.querySelector('.gm-style-iw-ch');
      if (header) {
        (header as HTMLElement).style.display = 'none';
      }

      const labelArrowDown = document.querySelector('.gm-style-iw-tc');
      if (labelArrowDown && this.LabelVehicleInfoHTML) {
        (labelArrowDown as HTMLElement).style.display = 'none';
      }

      const container = document.querySelector('.gm-style-iw-d');
      if (container) {
        (container as HTMLElement).style.removeProperty('overflow');
        (container as HTMLElement).style.removeProperty('max-height');
      }

      const infoWindowElements = document.querySelectorAll('.gm-style-iw');
      infoWindowElements.forEach((el) => {
        const iw = el as HTMLElement;
        iw.style.backgroundColor = '#FFF';
        iw.style.borderRadius = '6px';
        iw.style.padding = this.LabelVehicleInfoHTML ? '2px 9px' : '6px 8px';
        iw.style.fontSize = '14px';
        iw.style.boxShadow = '0px 5px 10px 5px rgba(194, 194, 194, 0.30)';
        iw.style.border = '1px solid var(--Grey-300, #C2C2C2)';
      });
    });
  }


  private loadDefaultPosition(): void {
    if (this.PublicRequestService.isPublicRoute()) {
      this.setDefaultPosition();
      return;
    }

    const userProfile: UserProfile | null = this.myAccountService.getUserDetailLocal();
    try {
      if (userProfile) {
        this.defaultPositionLatitude = userProfile.DefaultAddressLatitude ?? 41.410924;
        this.defaultPositionLongitude = userProfile.DefaultAddressLongitude ?? 2.1785351;
        this.initMap();
      } else {
        this.myAccountService.getUserDetail().subscribe({
          next: (data) => {
            if (data) {
              this.myAccountService.setUserDetailLocal(data);
              this.defaultPositionLatitude = data.DefaultAddressLatitude ?? 41.410924;
              this.defaultPositionLongitude = data.DefaultAddressLongitude ?? 2.1785351;
              this.initMap();
            } else {
              this.setDefaultPosition();
            }
          },
          error: () => {
            this.setDefaultPosition();
          }
        });
      }
    } catch {
      this.setDefaultPosition();
    }
  }

  setDefaultPosition() {
    this.defaultPositionLatitude = 41.410924;
    this.defaultPositionLongitude = 2.1785351;
    this.initMap();
  }

  initMap() {
    const mapElement = document.getElementById(this.mapID);
    if (mapElement) {

      this.map = new google.maps.Map(mapElement, {
        center: { lat: this.defaultPositionLatitude, lng: this.defaultPositionLongitude },
        zoom: 14,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        styles: this.onlyStreetLabelsStyle,
        disableDefaultUI: true,
      });

      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        if (this.markers.length > 0) {
          this.updateMap();
        }
        this.reverseGeocode(this.defaultPositionLatitude, this.defaultPositionLongitude);
      });
    } else {
      console.error('El elemento del mapa no está disponible en el DOM');
    }
  }

  updateMap() {
    if (this.map) {
      this.clearMapElements();
      if (this.markers.length === 0) {
        this.loadDefaultPosition();
        return;
      }
      this.renderMarkers(this.map);
      this.map.panTo({ lat: this.markers[0]?.lat, lng: this.markers[0]?.lng });
      if (this.markers.length > 1) {
        // if (!this.isActiveRoutes) {
        this.getRouteDirections(this.markers);
        // }
        this.fitBounds(this.map);
      }

      this.reverseGeocode(this.markers[0]?.lat, this.markers[0]?.lng);
      this.showTravelInfoWindow()
    }
  }


  reverseGeocode(lat: any, lng: any) {
    const geocoder = new google.maps.Geocoder();
    const latlng = { lat, lng };

    geocoder.geocode({ location: latlng }, (results: any, status: any) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          const addressComponents = results[0].address_components;
          let isBusiness = results[0].types.includes('establishment');
          let hasStreetNumber = false;

          addressComponents.forEach((component: any) => {
            if (component.types.includes('street_number')) {
              hasStreetNumber = true;
            }
          });

          if (isBusiness) {
          } else if (!hasStreetNumber) {
            this.locationSelected.emit();
          } else {
          }
        } else {
          console.error('No se encontraron resultados.');
        }
      } else {
        console.error('Geocodificación fallida: ' + status);
      }
    });
  }

  // private clearMarkers() {
  //   this.currentMarkers.forEach((marker) => marker.setMap(null));
  //   this.currentMarkers = [];
  //   if (this.polylines.length > 0) {
  //     this.polylines = []
  //   }
  // }

  renderMarkers(map: any) {
    this.markers.forEach((marker, index): void => {
      const newMarker = this.addMarker(marker, map, index);
      if (!newMarker) { return }
      this.currentMarkers.push(newMarker);
    });
  }

  addMarker(marker: MapData | any, map: any, index: number): google.maps.Marker | null {
    try {
      const newMarker = new google.maps.Marker({
        position: { lat: marker?.lat, lng: marker?.lng },
        map: map,
        icon: {
          url: marker?.icon?.url
            ? marker?.icon.url
            : index === 1
              ? '../../../assets/icons/destination-point-icon.svg'
              : '../../../assets/icons/origin-point-icon.svg',
          scaledSize: marker?.icon?.scaledSize ?? new google.maps.Size(32, 32),
          anchor: marker?.icon?.anchor ?? new google.maps.Point(16, 16),
        },
        optimized: false,
      });

      // 👉 Añadimos evento click
      newMarker.addListener('click', () => {
        this.markerClicked.emit(marker);
      });

      return newMarker;
    }
    catch {
      console.error("Error con marker de google maps, revisa las direcciones indicadas")
      return null;
    }
  }

  fitBounds(map: any) {
    if (
      this.markers[0].lat === this.markers[1].lat &&
      this.markers[0].lng === this.markers[1].lng
    ) {
      map.setCenter(new google.maps.LatLng(this.markers[0].lat, this.markers[0].lng));
      map.setZoom(15);
      return;
    }
    const bounds = new google.maps.LatLngBounds();
    this.markers.forEach((marker) => {
      bounds.extend(new google.maps.LatLng(marker.lat, marker.lng));
    });
    map.fitBounds(bounds);
  }

  private clearMapElements() {
    this.currentMarkers.forEach((marker) => marker.setMap(null));
    this.currentMarkers = [];
    if (this.polylines) {
      this.polylines.forEach(poly => poly.setMap(null));
      this.polylines = [];
    }
  }

  getRouteDirections(markers: MapData[]) {
    // Limpiar todas las rutas previas
    if (this.polylines && this.polylines.length > 0) {
      this.polylines.forEach(p => p.setMap(null));
    }
    this.polylines = [];

    // Agrupamos los marcadores por orderHash
    const groupedByOrder = markers.reduce((acc, marker) => {
      if (marker.type === MapMarkerType.DRIVER) return acc; // ignorar drivers
      if (!acc[marker.orderHash!]) acc[marker.orderHash!] = [];
      acc[marker.orderHash!].push(marker);
      return acc;
    }, {} as Record<string, MapData[]>);

    const directionsService = new google.maps.DirectionsService();

    // Recorremos cada grupo de orderHash
    Object.values(groupedByOrder).forEach(group => {
      const origin = group.find(m => m.type === MapMarkerType.ORIGIN);
      const destination = group.find(m => m.type === MapMarkerType.DESTINATION);

      if (!origin || !destination) {
        console.warn('No se encontró origen o destino para una orden.');
        return;
      }

      const request = {
        origin: new google.maps.LatLng(origin.lat, origin.lng),
        destination: new google.maps.LatLng(destination.lat, destination.lng),
        travelMode: google.maps.TravelMode.DRIVING,
      };

      directionsService.route(request, (response: any, status: any) => {
        if (status === google.maps.DirectionsStatus.OK) {
          const path = response.routes[0].overview_path;
          this.drawPolyline(path);
        } else {
          console.error('Error al obtener las direcciones:', status);
        }
      });
    });
  }

  drawPolyline(path: any[]) {
    const polyline = new google.maps.Polyline({
      path: path,
      geodesic: true,
      strokeColor: '#1e59f5',
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });

    polyline.setMap(this.map);
    this.polylines.push(polyline);
  }


}
